import { render } from "./ButtonFormBuilder.vue?vue&type=template&id=c2970a2a"
import script from "./ButtonFormBuilder.vue?vue&type=script&lang=ts"
export * from "./ButtonFormBuilder.vue?vue&type=script&lang=ts"
script.render = render

export default script